import { render, staticRenderFns } from "./addsuppliers.vue?vue&type=template&id=67f37018"
import script from "./addsuppliers.vue?vue&type=script&lang=js"
export * from "./addsuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports